var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"deal-card",attrs:{"data-cy":"deal-item"}},[_c('DealNotifications',{attrs:{"deal":_vm.deal}}),_c('deal-item',{ref:"dealItem",staticClass:"deal-card__inner deal-card__inner--top",class:{
      'deal-card__inner--top--hidden': _vm.topCardHidden,
    },attrs:{"deal":_vm.deal,"highlight":_vm.highlight},on:{"info-click":_vm.toggleTopCard,"cta-click":_vm.startEvaluation}}),_c('deal-item-options',{staticClass:"deal-card__inner deal-card__inner--bottom",attrs:{"deal":_vm.deal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }